import { useRecruitmentApi } from 'infrastructure/api';
import { useCrudService } from 'framework/crud';
import { SOURCING_FILTERS } from 'domain/recruiting/newVacancy/show/sourcing/useVacancySourcingService';

const SOURCING_API_PATH = '/candidates/saved-filters';

const useSavedCandidateFilterService = () => {
  const { sendGetRequest } = useRecruitmentApi();

  const { create: baseCreate, deleteById } = useCrudService({
    listResourceUrl: SOURCING_API_PATH,
    singleResourceUrl: `${SOURCING_API_PATH}/:id`,
    useService: useRecruitmentApi,
  });

  const mapForCreate = ({ searchFields, ...other }: any) => {
    const filters = Object.entries(searchFields).reduce(
      (acc: any, [field, value]: any) => {
        const fieldName =
          {
            level: 'qualificationLevel',
          }[field as string] || field;

        let finalValue = value;

        if (field === SOURCING_FILTERS.lastInteraction && Array.isArray(value)) {
          const [from = '', to = ''] = value;
          finalValue = { from, to };
        }

        acc[fieldName] = {
          value: finalValue,
          mode: searchFields.stricts.includes(field) ? 'STRICT' : 'NON_STRICT',
        };
        return acc;
      },
      {
        specialization: '',
      },
    );
    return {
      ...other,
      searchFields: filters,
    };
  };

  const create = async (data: any) => {
    const mapped = mapForCreate(data);
    return baseCreate(mapped);
  };

  const mapToFilter = ({ id, name, searchFields }: any) => {
    const filters = Object.entries(searchFields).reduce(
      (acc: any, [field, value]: any) => {
        if (!value) {
          return acc;
        }

        acc[field] = value.value;
        if (value.mode === 'STRICT') {
          acc.stricts.push(field);
        }
        return acc;
      },
      {
        stricts: [],
        qualificationLevel: [],
        location: [],
        englishLevel: [],
        skills: [],
        tags: [],
      },
    );
    return {
      id,
      name,
      searchFields: normalizeSavedFilter(filters),
    };
  };

  const getFiltersForGroup = async (groupId: string) => {
    const response = await sendGetRequest(`${SOURCING_API_PATH}?groupId=${groupId}`);
    const parsed = await response.json();
    return parsed.result.map(mapToFilter);
  };

  const normalizeSavedFilter = (filterFields: any) => {
    const transformed: any = { ...filterFields };

    if (filterFields.lastInteraction && typeof filterFields.lastInteraction === 'object') {
      const { from, to } = filterFields.lastInteraction;

      if (from || to) {
        transformed.lastInteraction = [from || '', to || ''];
      } else {
        delete transformed.lastInteraction;
      }
    }

    return transformed;
  };

  return {
    getFiltersForGroup,
    create,
    deleteById,
  };
};

export default useSavedCandidateFilterService;
